const ApplicationView = (data) => {
  console.log("data --->", data?.data);
  return (
    <div>
      <h1 className="text-xl mb-4 font-bold">Application</h1>
      {data?.data?.map((eachApplication, index) => {
        return (
          <div
            key={index}
            className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 bg-neutral-100 p-4 rounded-sm"
          >
            <div>
              <h3 className="font-semibold text-lg text-gray-900">Position</h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachApplication?.position || "No position specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">Address</h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachApplication?.companyAddress || "No address specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">
                Certificate
              </h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachApplication?.certificate || "No certificate specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">grade</h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachApplication?.gpa || "No grade specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">From</h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachApplication?.startYear || "No year specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">Status</h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachApplication?.status || "No status specified"}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ApplicationView;
